
import layerEvents from "../utils/layerEvents";
import Workmode from "../classes/Workmode";
import WorkmodeProject from "../classes/WorkmodeProject";
import { Pentagon, Info, Building, Polygon  } from "@phosphor-icons/react";
import {Dropdown, Button, Row, Col} from "react-bootstrap";


class WorkmodeComp extends WorkmodeProject {


	constructor() {
		super();
		

	}
	propertyAttributes(land, landOwners){
		const {getters} = this.context;
		var stats = [0,0];
		if(landOwners.length){

			const lId = landOwners[0]

			const o = this.tc.scenario.landowners.find((ow)=>{return ow.id == lId});

			if(o){
				const prop = o.properties.find((p)=>{return p.id == land.properties.vindrid});
				if(prop && prop.area && prop.totalArea)
					stats = [prop.totalArea, prop.area];
			}
			else {
				stats = [0,0];
			}
		}
		
		return (
			<>
				{!!land.properties.vindrid &&
				<Row className="basic-info mb-2">
					<Col xs="12">
						<i className="ri-circle-fill mr-2" style={{color:land.properties.color}}></i>

						<button className="btn btn-text p-0">
							<b>ID: </b>
							{land.properties.vindrid }
						</button>
					</Col>
				</Row>
				}


				{landOwners.length>1 &&
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Info className="text-warning mr-2" size={16} />
						This property has multiple owners
					</Col>
				</Row>
				}

				{!!land.properties.name && 
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Building size={16} />
						<b>Name: </b>
						{land.properties.name}
					</Col>
				</Row>
				}
				
			</>
		);
	}
}

export default WorkmodeComp;